import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';

import { API_URL } from "./api-url";

@Injectable()
export class Api {
  protected url: string;

  constructor(public http: HttpClient) {
    this.url = API_URL;
  }

  protected handleError(error: Response | any) {
    return Observable.throw(error);
  }
}


// WEBPACK FOOTER //
// ./src/providers/api.ts